/**
 * 全局混入
 */
import Header from '@/components/header'
import ModelDialog from '@/components/ModelDialog'
import newHead from "@/components/newHead.vue";
import myTable from "@/components/my-table.vue";
import nothingCom from "@/components/nothingCom.vue";
import MyTabs from "@/components/my-tabs.vue";
import downloadUrl from '@/components/downloadUrl.vue'
import {
    PullRefresh,
    List,
    Toast
} from 'vant'

export default {
    components: {
        Header,
        newHead,
        ModelDialog,
        myTable,
        nothingCom,
        MyTabs,
        downloadUrl,
        PullRefresh,
        List
    },
    methods: {
        // 判断任务是否可领取逻辑比较复杂  返回一个布尔值（是否可领取） + 按钮提示文字
        isReceiveFn(item) {
            console.log({
                ...item
            });
            let userInfo = JSON.parse(localStorage.getItem("userInfo"))
            let res = {
                isReceive: true,
                statusText: '领取任务'
            }
            if (item.is_pink == 1) {
                res.isReceive = false
                res.statusText = '已领取'
                return res
            }
            if (new Date(item.plan_end_time).valueOf() <= new Date().valueOf()) {
                res.isReceive = false
                res.statusText = '任务已过期'
                return res
            }
            if (userInfo.is_working != item.type) {
                res.isReceive = false
                res.statusText = '任务类型不匹配'
                return res
            }
            if ((item.task_mech === '悬赏') && (item.max_pick != 0) && (item.pick >= item.max_pick)) {
                res.isReceive = false
                res.statusText = '已领取完毕'
                return res
            }
            if ((item.task_mech === '悬赏') && (item.max_pick != 0) && (item.pick <= item.max_pick)) {
                res.statusText = `领取${item.pick}/${item.max_pick}`
            }
            return res
        },
        tip(t) {
            Toast(t)
        },
        strToArr(str) {
            return str.split(',')
        },
        moneyFormat(money) {
            let num = Number(money)
            if (num >= 1000) {
                var a = String(num);
                var d1 = a.slice(0, -3) + "," + a.slice(-3)
                return d1
            }
            return num
        },
        timeFormat(date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            var d = date.getDate();
            let newTime = y + '-' + (m < 10 ? (`0${m}`) : m) + '-' + (d < 10 ? (`0${d}`) : d)
            return newTime
        },
        timestampFormat(timestamp) {
            if (timestamp == '') {
                return '/'
            }
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            let strDate = Y + M + D + ' ' + h + m + s;
            return strDate;
        },

    }
}